'use strict';

/**
 * Filtre highlight — met en surbrillance les occurrences d'un terme dans un texte.
 * Usage : {{ item.titre | highlight:query }}
 */
angular.module('observatoireApp')
  .filter('highlight', ['$sce', function($sce) {
    return function(text, search) {
      if (!search || !text) return text;
      var escaped = search.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
      var regex = new RegExp('(' + escaped + ')', 'gi');
      var result = String(text).replace(regex, '<mark>$1</mark>');
      return $sce.trustAsHtml(result);
    };
  }]);
